import { StatusBar, Style } from '@capacitor/status-bar';

export const configureStatusBarStyle = async newStyle => {
    let style = Style.Default;
    if (newStyle) {
        if (newStyle === 'light') style = Style.Light;
        if (newStyle === 'dark') style = Style.Dark;
    }

    await StatusBar.setStyle({ style });
};
